module.exports = __webpack_public_path__ + "static/media/email.2d4e702d.svg";